import { render, staticRenderFns } from "./AmountCard.vue?vue&type=template&id=751fa9d2"
import script from "./AmountCard.vue?vue&type=script&lang=ts"
export * from "./AmountCard.vue?vue&type=script&lang=ts"
import style0 from "./AmountCard.vue?vue&type=style&index=0&id=751fa9d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports